import { RouteObject } from "react-router-dom";
import RequireAuth from "../../auth/requireAuth";
import { SettingContainer } from "../setting/settingContainer";
import { Module } from "../../assets/types";
import { SettingDto } from "../../services/dto/popHub/settingDto";
import { QuestionTypeContainer } from "./lookupQuestiontype/questionTypeContainer";
import { LookupTypeContainer } from "../lookup/lookuptype/lookupTypeContainer";
import { LookupCategoryDto } from "../../services/dto/questionnaire/lookupCategoryDto";
import { LookupGroupContainer } from "../lookup/lookupgroup/lookupGroupContainer";
import { LookupGroupDto } from "../../services/dto/questionnaire/lookupGroupDto";
import { LookupValueContainer } from "../lookup/lookupvalue/lookupValueContainer";
import { LookupDto } from "../../services/dto/questionnaire/lookupDto";
import { AnswerTypeContainer } from "./lookupAnswertype/answerTypeContainer";
import { permissions } from "../../assets/configuration/claimSettings";

export const QuestionnaireRoutes: RouteObject = {
    path: "questionnaire",
    children: [
        {
            path: "lookuptype",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupTypeContainer<LookupCategoryDto> moduleType={Module.Questionnaire} />
                </RequireAuth>
            ),
        },
        {
            path: "lookupgroup",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupGroupContainer<LookupGroupDto> moduleType={Module.Questionnaire} />
                </RequireAuth>
            ),
        },
        {
            path: "lookupvalue",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupValueContainer<LookupDto> moduleType={Module.Questionnaire} />
                </RequireAuth>
            ),
        },
        {
            path: "settings",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <SettingContainer<SettingDto> moduleType={Module.Questionnaire} />
                </RequireAuth>
            ),
        },
        {
            path: "questiontype",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageQuestionnaire]}>
                    <QuestionTypeContainer  />
                </RequireAuth>
            ),
        },
        {
            path: "answertype",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageQuestionnaire]}>
                    <AnswerTypeContainer />
                </RequireAuth>
            ),
        },

    ],
};
